/* eslint-disable react/react-in-jsx-scope */
import AssignmentIcon from '@mui/icons-material/Assignment'
import PostAddIcon from '@mui/icons-material/PostAdd'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import LockIcon from '@mui/icons-material/Lock'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import BackupTableIcon from '@mui/icons-material/BackupTable'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import ScheduleIcon from '@mui/icons-material/Schedule'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined'
import HouseSidingIcon from '@mui/icons-material/HouseSiding'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo'
import ListAltIcon from '@mui/icons-material/ListAlt'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import HowToRegIcon from '@mui/icons-material/HowToReg'
import InsightsIcon from '@mui/icons-material/Insights'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import { RouteDataItem } from '../../types/Core/Routes'

export const routeData: RouteDataItem[] = [
	{
		title: 'Projects',
		routesPath: 'projects',
		path: '/projects',
		icon: <PostAddIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'OfficeAdmin'],
		templates: [0, 1],
		requiredPermissions: [
			2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
			27, 28, 29, 30, 31, 32, 33, 85, 91, 92, 95, 96, 97,
		],
	},
	{
		title: 'Projects',
		routesPath: 'projects',
		path: '/projects',
		icon: <PostAddIcon />,
		defaultRoute: false,
		roles: ['Foreman', 'GeneralForeman', 'Superintendent'],
		templates: [1],
	},
	{
		title: 'Backlog',
		path: '/backlog',
		routesPath: 'backlog/*',
		icon: <AssignmentIcon />,
		defaultRoute: true,
		roles: [
			'ProjectControls',
			'SuperAdmin',
			'Foreman',
			'GeneralForeman',
			'Superintendent',
			'OfficeAdmin',
		],
		templates: [0],
		requiredPermissions: [34, 35, 36, 37, 38, 39, 40, 41, 42, 43],
	},
	{
		title: 'Attendance',
		routesPath: 'attendance/*',
		path: '/attendance',
		icon: <HowToRegIcon />,
		defaultRoute: false,
		roles: [
			'ProjectControls',
			'Superintendent',
			'SuperAdmin',
			'GeneralForeman',
			'Foreman',
			'OfficeAdmin',
		],
		templates: [1],
		requiredPermissions: [53, 54, 55, 56, 57, 70],
	},
	{
		title: 'Work Entry',
		routesPath: 'workEntry/*',
		path: '/workEntry',
		icon: <ContentPasteGoIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'Superintendent', 'GeneralForeman', 'Foreman'],
		templates: [1],
		requiredPermissions: [76, 81],
	},
	{
		title: 'Work Scope Register',
		routesPath: 'workScopeRegister/*',
		path: '/workScopeRegister',
		icon: <ListAltIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'Superintendent', 'GeneralForeman', 'Foreman'],
		templates: [1],
		requiredPermissions: [76, 81],
	},
	{
		// Template 1 entry/default for Foreman, Superintendent, GeneralForeman, and ProjectControls
		title: 'Time Entry',
		routesPath: 'payrollEntry/*',
		path: '/payrollEntry',
		icon: <AccessTimeIcon />,
		defaultRoute: true,
		roles: ['ProjectControls', 'Superintendent', 'SuperAdmin', 'GeneralForeman', 'Foreman'],
		templates: [1],
		requiredPermissions: [82, 83, 84],
	},
	{
		title: 'Time Acceptance',
		routesPath: 'timeAcceptance/*',
		path: '/timeAcceptance',
		icon: <FactCheckIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'OfficeAdmin'],
		templates: [1],
		requiredPermissions: [99, 100, 101, 102, 85],
	},
	{
		title: 'Inspection Backlog',
		routesPath: 'qcBacklog/*',
		path: '/qcBacklog',
		icon: <VerifiedUserIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'QualityControl'],
		templates: [0, 1],
		requiredPermissions: [51],
	},
	{
		title: 'Assign Work',
		routesPath: 'workitems/*',
		path: '/workitems',
		icon: <PostAddIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'Superintendent', 'SuperAdmin', 'GeneralForeman'],
		templates: [0],
		requiredPermissions: [44, 60, 61, 75],
	},
	{
		title: 'Labor Assignments',
		routesPath: 'labor/*',
		path: '/labor',
		icon: <AccountTreeIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'OfficeAdmin'],
		templates: [0, 1],
		requiredPermissions: [45, 46, 73],
	},
	{
		title: 'Employee Schedule',
		routesPath: 'schedule/*',
		path: '/schedule',
		icon: <CalendarMonthIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'OfficeAdmin'],
		templates: [0, 1],
		requiredPermissions: [86, 87, 88, 89, 90],
	},
	{
		title: 'Work Items Overview',
		routesPath: 'workitems/overview/*',
		path: '/workitems/overview',
		icon: <FormatListBulletedIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'Superintendent', 'SuperAdmin', 'GeneralForeman'],
		templates: [0],
		requiredPermissions: [47, 48, 49, 50, 74],
	},
	{
		title: 'Shift End Report',
		routesPath: 'reports/*',
		path: '/reports',
		icon: <ScheduleIcon />,
		defaultRoute: true,
		roles: [
			'ProjectControls',
			'Superintendent',
			'SuperAdmin',
			'GeneralForeman',
			'Foreman',
			'OfficeAdmin',
		],
		templates: [0],
		requiredPermissions: [53, 54, 55, 56, 57, 70],
	},
	{
		title: 'Constraints',
		routesPath: 'constraints/*',
		path: '/constraints',
		icon: <LockIcon />,
		defaultRoute: true,
		roles: ['ProjectControls', 'Superintendent', 'SuperAdmin', 'GeneralForeman'],
		templates: [0],
	},
	{
		title: 'Inspections',
		routesPath: 'inspections/*',
		path: '/inspections',
		icon: <BackupTableIcon />,
		defaultRoute: true,
		roles: ['ProjectControls', 'SuperAdmin', 'QualityControlManager'],
		templates: [0, 1],
		requiredPermissions: [52],
	},
	{
		title: 'Surveys',
		routesPath: 'surveys/*',
		path: '/surveys',
		icon: <SquareFootIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'LineTech', 'LineTechManager'],
		templates: [0, 1],
		requiredPermissions: [58, 59],
	},
	{
		title: 'Change Orders',
		routesPath: 'changeOrders/*',
		path: '/changeOrders',
		icon: <ReceiptLongIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin'],
		templates: [0, 1],
		requiredPermissions: [62],
	},
	{
		title: 'Material Preparation',
		routesPath: 'material/*',
		path: '/material',
		icon: <WarehouseOutlinedIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'MaterialManager', 'Material'],
		templates: [0],
		requiredPermissions: [63, 64, 65, 66, 67],
	},
	{
		title: 'Scaffold Orders',
		routesPath: 'scaffoldOrders/*',
		path: '/scaffoldOrders',
		icon: <HouseSidingIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'OfficeAdmin'],
		templates: [0],
		requiredPermissions: [37, 68, 69, 78, 80],
	},
	{
		title: 'Equipment Log',
		routesPath: 'equipment/*',
		path: '/equipment',
		icon: <PrecisionManufacturingIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin', 'OfficeAdmin'],
		templates: [0, 1],
		requiredPermissions: [77],
	},
	{
		title: 'Contract Management',
		routesPath: 'contractManagement/*',
		path: '/contractManagement',
		icon: <DescriptionOutlinedIcon />,
		defaultRoute: false,
		roles: [
			'ProjectControls',
			'SuperAdmin',
			'OfficeAdmin',
			'Foreman',
			'GeneralForeman',
			'Superintendent',
		],
		templates: [1],
	},
	{
		title: 'Analytics',
		routesPath: 'analytics/*',
		path: '/analytics',
		icon: <InsightsIcon />,
		defaultRoute: false,
		roles: ['ProjectControls', 'SuperAdmin'],
		templates: [0, 1],
		requiredPermissions: [98],
	},
]
